import {
    HttpErrorResponse,
    HttpInterceptorFn
} from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, finalize, throwError } from 'rxjs';

import { StorageService } from 'core/services/storage.service';
import { RouterService } from 'core/services/router.service';
import { HTTP_STATUS } from 'shared/enums/common.enum';
import { LoaderService } from 'core/services/loader.service';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'shared/interfaces/response';
import { AlertService } from 'core/services/alert.service';
import { SKIP_GLOBAL_LOADER } from 'core/tokens/http-context.token';

export const AuthInterceptor: HttpInterceptorFn = (req, next) => {
    const storageService = inject(StorageService);
    const routerService = inject(RouterService);
    const loader = inject(LoaderService);
    const alert = inject(AlertService);
    // const translation = inject(TranslationService)

    let url = req.url;

    if(shouldAttachBaseURL(url)){
        url = `${environment.apiBaseUrl}/${req.url}`
    }

    const modifiedReq = req.clone({
        url,
        setHeaders: {
            Authorization: `Bearer ${storageService.accessToken}`
        },
    });

    const skipLoader = req.context.get(SKIP_GLOBAL_LOADER) || !shouldAttachBaseURL(url);

    if(!skipLoader){
        if(loader.pendingRequests <= 0){
            queueMicrotask(() => loader.show());
        }
        loader.pendingRequests++;
    }
    
    return next(modifiedReq).pipe(
        catchError((error) => {
            const response = error.error as ApiResponse<null>;
            response.errors?.forEach(e => alert.errorToaster(e.message));
            if (error instanceof HttpErrorResponse) {
                if (error.status === HTTP_STATUS.UNAUTHORIZED) {
                    storageService.clearStorage();
                    routerService.goToLogin();
                }else if(error.status === HTTP_STATUS.FORBIDDEN) {
                    alert.errorToaster(response.message);
                }
            }

            return throwError(() => error);
        }),
        finalize(() => {
            if(!skipLoader){
                loader.pendingRequests--;
                if(loader.pendingRequests <= 0){
                    queueMicrotask(() => loader.hide())
                }
            }
        })
    )
};


const shouldAttachBaseURL = (url: string) => {
    const assets = ['assets/i18n', 'assets/images', 'assets/gifs', 'assets/fonts']
    return !assets.some(a => url.includes(a));
}